export default __webpack_public_path__ + "static/media/ABK.26d1664a.jpg";